import { Outlet } from "react-router-dom";

const AssetsParentPage = () => {
    return (
        <Outlet />
    );
}

export default AssetsParentPage;
